import { render, staticRenderFns } from "./HolidayModal.vue?vue&type=template&id=40014ce4&scoped=true"
import script from "./HolidayModal.vue?vue&type=script&lang=js"
export * from "./HolidayModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40014ce4",
  null
  
)

export default component.exports